import { render, staticRenderFns } from "./lactateTextAdd.vue?vue&type=template&id=2f4efe79&scoped=true"
import script from "./lactateTextAdd.vue?vue&type=script&lang=js"
export * from "./lactateTextAdd.vue?vue&type=script&lang=js"
import style0 from "./lactateTextAdd.vue?vue&type=style&index=0&id=2f4efe79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4efe79",
  null
  
)

export default component.exports